import Vue from 'vue'
import * as jsonpatch from 'fast-json-patch/index.mjs'

const applicationStatusHistory = {
  state: {
    applicationStatusHistories: [],
    selectedApplicationStatusHistory: {},
    selectedApplicationStatusHistoryOriginal: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    applicationStatusHistories(state) {
      return state.applicationStatusHistories
    },
    selectedApplicationStatusHistory(state) {
      return state.selectedApplicationStatusHistory
    },
    selectedApplicationStatusHistoryOriginal(state) {
      return state.selectedApplicationStatusHistoryOriginal
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    applicationStatusHistories(state, payload) {
      state.applicationStatusHistories = payload
    },
    selectedApplicationStatusHistory(state, payload) {
      state.selectedApplicationStatusHistory = JSON.parse(JSON.stringify(payload))
    },
    selectedApplicationStatusHistoryOriginal(state, payload) {
      state.selectedApplicationStatusHistoryOriginal = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedApplicationStatusHistory(context, payload) {
      context.commit('selectedApplicationStatusHistory', payload)
    },
    async loadApplicationStatusHistories(context, payload) {
      const url = 'ApplicationStatusHistory'
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('applicationStatusHistories', res.data)
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    refreshSelectedApplicationStatusHistory(context, payload) {
      if (context.state.selectedApplicationStatusHistory && context.state.selectedApplicationStatusHistory.Id > 0) {
        context.dispatch('loadSelectedApplicationStatusHistory', context.state.selectedApplicationStatusHistory.Id)

      }
    },
    async loadSelectedApplicationStatusHistory(context, payload) {
      if (context.state.selectedApplicationStatusHistory && context.state.selectedApplicationStatusHistory.Id != payload) {
        context.commit('selectedApplicationStatusHistory', {})
      }
      const url = 'ApplicationStatusHistory/' + payload
      context.commit('increaseSearchCount')
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('selectedApplicationStatusHistory', res.data)
        context.commit('selectedApplicationStatusHistoryOriginal', res.data)
        context.commit('decreaseSearchCount')
        return res
      } catch (err) {
        console.error(err)
        context.commit('decreaseSearchCount')
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    clearLookupCacheAndReloadApplicationStatusHistories(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
          context.dispatch('loadApplicationStatusHistories')
      }, )
    },
    async createApplicationStatusHistory(context, payload){
      const url = `ApplicationStatusHistory`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.post(url, payload)
        context.dispatch('messages/toastMessage',
        {color: 'success', message: 'application status history created',},{ root: true })
        //if you will always need to reload the list after an item is created
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadApplicationStatusHistories')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async patchApplicationStatusHistory(context, payload){
      var item = context.state.selectedApplicationStatusHistory
      if (payload.Id && 
      payload.Id == context.state.selectedApplicationStatusHistoryOriginal.Id)  {
      item = payload
      }
      var patchPayload = {}
      if (!payload.patchDoc || !payload.Id) {
        let original = context.state.selectedApplicationStatusHistoryOriginal
        let current = item
        patchPayload.Id = item.Id
        var diff = jsonpatch.compare(
              original,
              current
            )
        patchPayload.patchDoc = diff

      } else {
        patchPayload = payload
      }
      if (patchPayload.patchDoc.length > 0) {
        const url = `ApplicationStatusHistory/${ patchPayload.Id }`
        context.commit('saving', true)
        try {
          let res = await Vue.prototype.$axios
          .patch(url, patchPayload.patchDoc)
          context.dispatch('messages/toastMessage',
          {color: 'success', message: 'application status history updated',},{ root: true })
          //if you will always need to reload the list after an update
          //you can uncomment out the following dispatch line.
          //Alternatively you can reload whatever object you need
          //when the promise resolves in the component that called it.
          //context.dispatch('loadApplicationStatusHistories')
          context.commit('saving', false)
          return res
        } catch (err) {
          console.error(err)
          context.commit('saving', false)
          context.dispatch('errors/handleError', err, { root: true })
          throw err
        }
      } else {
        return 'no changes'
      }
    },
    async updateApplicationStatusHistory(context, payload){
      const url = `ApplicationStatusHistory/${ payload.Id }`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios
          .put(url, payload)
        context.dispatch('messages/toastMessage',
        {color: 'success', message: 'application status history updated',},{ root: true })
        //if you will always need to reload the list after an update
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadApplicationStatusHistories')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async saveApplicationStatusHistory(context, payload){
      if (payload.Id > 0) {
        return context.dispatch('updateApplicationStatusHistory', payload)
      } else {
        return context.dispatch('createApplicationStatusHistory', payload)
      }
    },
    async deleteApplicationStatusHistory(context, payload){
      const url = `ApplicationStatusHistory/${ payload.Id }`
      try {
        let res = await Vue.prototype.$axios.delete(url)
        context.dispatch('messages/toastMessage',
        {color: 'success', message: 'application status history deleted',},{ root: true })
        //if you will always need to reload the list after a delete
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadApplicationStatusHistories')
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
  },
}

export default applicationStatusHistory